// A small connection-status bar: who else is active on the canvas
// (ActiveCanvasUsers) + the connection status navbar (ConnectionNavbar).
// Renamed from `CanvasConnection` 2026-07-27 — that bare name collided with
// the real SVG edge renderer at packages/canvas/components/CanvasConnection.js
// (the 88-line `<g>`/HitArea/Visible bezier-edge component used by
// /team-and-agents' `childExtends: 'CanvasConnection'`). canvas's own eager
// component barrel wins that name in every context canvas is linked
// (workspace shell, canvas's own standalone build), so this flex-strip
// component only ever rendered in scopes that link `shared` WITHOUT canvas
// (marketplace/preview/demo/gazer) — and nothing in those packages actually
// referenced it by name. See tickets/workspace.md (CanvasConnection
// duplicate-name collision).
export const CanvasConnectionBar = {
  flow: 'x',
  ActiveCanvasUsers: {},
  ConnectionNavbar: {},
  gap: 'Z2'
}
